/**
 * API Client Types
 * Type definitions for API requests, responses, and errors
 */
/**
 * Runtime error returned when an API request fails.
 *
 * It preserves the structural `ApiError` fields while remaining compatible
 * with standard Error handling, logging, and `instanceof` checks.
 */
export class ApiClientError extends Error {
    constructor({ code, message, details, statusCode, timestamp }) {
        super(message);
        this.name = 'ApiClientError';
        this.code = code;
        if (details !== undefined)
            this.details = details;
        if (statusCode !== undefined)
            this.statusCode = statusCode;
        if (timestamp !== undefined)
            this.timestamp = timestamp;
    }
}
